import { PlanOverview } from "@/components/plans/PlanOverview";

interface Props {
  planId: string;
}

export function PlanOverviewPage({ planId }: Props) {
  return <PlanOverview planId={planId} />;
}
